export const REACT_FLOW_CHART = 'react-flow-chart';
